import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetPostPoll, EResetPostPollActionType } from './types';

export const resetPostPoll: () => TResetPostPoll = actionGenerator<EResetPostPollActionType.Reset>(
  EResetPostPollActionType.Reset,
);
